module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading_with_sub/heading_with_sub_2-0a14fe1af0f4e07ecd06a1f70ccc466f.png";